import { render, staticRenderFns } from "./InfoColumnContacts.vue?vue&type=template&id=7de7301e&"
import script from "./InfoColumnContacts.vue?vue&type=script&lang=ts&"
export * from "./InfoColumnContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports